export const RUGBY_URBA_12_MATCHES = [
  {
    team1: 'belgrano athletic',
    team2: 'newman',
    day: 'Viernes - en vivo',
    time1: '20:10',
    time2: '19:10',
    time3: '18:10',
    region1: 'arg/cl',
    region2: 'bo',
    region3: 'co',
    channel: 'espn',
    tournament: 'generico',
    round: 'semifinal',
    date: '2025-10-24'
  },
  {
    team1: 'casi',
    team2: 'sic',
    day: 'Sábado - en vivo',
    time1: '17:10',
    time2: '16:10',
    time3: '15:10',
    region1: 'arg/cl',
    region2: 'bo',
    region3: 'co',
    channel: 'espn',
    tournament: 'generico',
    round: 'semifinal',
    date: '2025-10-25'
  }
];
